export { DNS_FIELD_KEYS, DNS_FIELD_KEY_LIST } from '../../utils/dnsFieldKeys';

export const DNS_ACTION_KEYS = {
  nameserverAdd: 'dns.nameserver.add',
  nameserverRemove: 'dns.nameserver.remove',
  searchAdd: 'dns.search.add',
  searchRemove: 'dns.search.remove',
  optionAdd: 'dns.option.add',
  optionRemove: 'dns.option.remove',
} as const;

export const DNS_ACTION_KEY_LIST = Object.values(DNS_ACTION_KEYS);
